import { render } from "./LatestNewsPage.vue?vue&type=template&id=78de2e54&scoped=true"
import script from "./LatestNewsPage.vue?vue&type=script&lang=js"
export * from "./LatestNewsPage.vue?vue&type=script&lang=js"

import "./LatestNewsPage.vue?vue&type=style&index=0&id=78de2e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78de2e54"]])

export default __exports__